import React from 'react'
import ReactDOM from 'react-dom'
import store from './store'
import { Provider } from 'react-redux'
import Navigation from './modules/navigation'
import "@babel/polyfill";
import "react-app-polyfill/ie9"
import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import 'raf/polyfill';

const Root: React.FC = (): React.ReactElement => (
  <Provider store={store}>
    <Navigation />
  </Provider>
)

const domContainer = document.querySelector('.dogley-booking-app');

if (domContainer) {
  if(domContainer) ReactDOM.render(<Root />, domContainer);
}
